import React from "react";
import ReactWOW from "react-wow";

const Prizes = () => (
  <section id="prizes" className="white">
    <div className="container">
      <div className="section-title">
        <h2>Prizes</h2>
        <p>The Top 3 teams will win attractive cash prizes!</p>
      </div>
      <div className="flex-box">
        <ReactWOW animation="fadeInUp" delay="0.1s">
          <div className="box box-3">
            <img src="images/prize-01.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">Champion</strong>
              <ul>
                <li className="price">S$ 3,000</li>
                <li className="reward">
                  Full-time / internship opportunities in Shopee
                </li>
              </ul>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.2s">
          <div className="box box-3">
            <img src="images/prize-02.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">1st Runner-Up</strong>
              <ul>
                <li className="price">S$ 2,000</li>
                <li className="reward">
                  Full-time / internship opportunities in Shopee
                </li>
              </ul>
            </div>
          </div>
        </ReactWOW>
        <ReactWOW animation="fadeInUp" delay="0.3s">
          <div className="box box-3">
            <img src="images/prize-03.png" alt="" className="img-prize" />
            <div className="content">
              <strong className="name">2nd Runner-Up</strong>
              <ul>
                <li className="price">S$ 1,000</li>
                <li className="reward">
                  Full-time / internship opportunities in Shopee
                </li>
              </ul>
            </div>
          </div>
        </ReactWOW>
      </div>
      <div className="section-footer">
        {/* <p>
          All participants will receive a certificate of accomplishment at the
          end of the competition only if their project has been submitted
          successfully before the deadline.
        </p> */}
        <p>
          Please note that for the full-time/internship opportunities, actual
          placements are not guaranteed. It will be dependent on candidate’s fit
          during interviews.
        </p>
      </div>
    </div>
  </section>
);

export default Prizes;
